<template>
  <div>
    <div class="col-12">
      <page-header :page="page" />
    </div>
    <div v-if="alerts.length > 0" class="row mx-0">
      <div class="col-md-12">
        <div class="mt-5">
          <custom-carousel
            class="custom-carousel__extended"
            :items="alerts"
            :size-per-slide="6"
          />
        </div>
        <!-- @go-to-details="goToDetailsHandler" -->
      </div>
    </div>

    <div class="col-12 flip-cards-container">
      <square-option
        v-for="(option, index) in optionList"
        :key="index"
        :option="option"
      />

      <square-option
        :option="{
          title: 'Configuraciones',
          description: 'Mantenimiento de Configuraciones del Sistema',
          detail: 'detalle',
          icon: 'fas fa-cog',
          mainImage: './img/card-prov-remedy-req-management-hover.bc782098.svg',
          hoverImage:
            './img/card-prov-remedy-req-management-hover.bc782098.svg',
          needSelectedStudent: false,
          route: '/support/settings',
        }"
      />
    </div>
  </div>
</template>

<script>
import CustomCarousel from 'custom-carousel';
import { mapState } from 'vuex';
import PageHeader from 'PageHeader';
import SquareOption from '@/components/common/SquareOption.vue';
import { name as userModuleName } from '@/store/modules/user';
import navMenuTitles from '@/utils/constants/navMenuTitles';

//import circle images
import circleAlertTypes from '@/utils/constants/circleAlertTypes.js';
import CIRCLE_IMAGE_ONE from '@/assets/img/circle_alert_one.svg';
import CIRCLE_IMAGE_TWO from '@/assets/img/circle_alert_two.svg';
import CIRCLE_IMAGE_THREE from '@/assets/img/circle_alert_three.svg';
import CIRCLE_IMAGE_FOUR from '@/assets/img/circle_alert_four.svg';
import { getQualityStadistics as _getQualityStadistics } from '@/services/support/support.api.js';

export default {
  components: {
    SquareOption,
    PageHeader,
    CustomCarousel,
  },
  data() {
    return {
      alerts: [],
      page: {
        icon: 'fas fa-user-cog',
        title: 'Soporte',
        routes: ['Inicio', 'Soporte'],
      },
    };
  },
  computed: {
    ...mapState(userModuleName, ['userMenu']),
    optionList() {
      return (
        this.userMenu
          .find((x) => x.title === navMenuTitles.Support)
          ?.children.map((item) => ({
            title: item.title,
            description: item.description,
            detail: item.detail,
            icon: item.iconClasses,
            mainImage: item.mainImagePath,
            hoverImage: item.mainImageHoverPath,
            needSelectedStudent: item.needSelectedStudent,
            route: item.navigationPath,
          })) || []
      );
    },
  },
  methods: {
    async getAlerts() {
      const { data } = await _getQualityStadistics();
      this.alerts = data.map((item) => {
        item.total = this.$options.filters.numberWithCommas(item.total);
        switch (item.type) {
          case circleAlertTypes.CircleOne:
            item.image = CIRCLE_IMAGE_ONE;
            break;
          case circleAlertTypes.CircleTwo:
            item.image = CIRCLE_IMAGE_TWO;
            break;
          case circleAlertTypes.CircleThree:
            item.image = CIRCLE_IMAGE_THREE;
            break;
          case circleAlertTypes.CircleFour:
            item.image = CIRCLE_IMAGE_FOUR;
            break;
          default:
            item.image = CIRCLE_IMAGE_ONE;
        }
        return item;
      });
    },
    goToDetailsHandler({ alertTypeId }) {
      if (alertTypeId) {
        this.$router.push({
          name: 'alertDetails',
          params: {
            id: alertTypeId,
          },
        });
      }
    },
  },
  async mounted() {
    await this.getAlerts();
  },
};
</script>
